import { Item, ItemHeader, ItemTitle, ScrollArea } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const CLASS_ITEMS = [
  { id: 'fio', labelKey: 'classes.fio' as const },
  { id: 'fio/dictionaries', labelKey: 'classes.fioDictionaries' as const },
  { id: 'phone', labelKey: 'classes.phone' as const },
  { id: 'birth-date', labelKey: 'classes.birthDate' as const },
  { id: 'passport', labelKey: 'classes.passport' as const },
  { id: 'snils', labelKey: 'classes.snils' as const },
  { id: 'inn', labelKey: 'classes.inn' as const },
  { id: 'bank-card', labelKey: 'classes.bankCard' as const },
  { id: 'bank-account', labelKey: 'classes.bankAccount' as const },
  { id: 'benchmark-testing', labelKey: 'classes.benchmarkTesting' as const },
];

type Props = {
  activeClass?: string;
};

export const AnonymizerClassList: FC<Props> = ({ activeClass }) => {
  const { t } = useTranslation('anonymizerConfig');
  const navigate = useNavigate();

  const handleSelect = (classId: string) => {
    navigate(`/anonymizer-config/${classId}`);
  };

  return (
    <ScrollArea className="h-full">
      <ul className="flex flex-col gap-2">
        {CLASS_ITEMS.map((item) => {
          const isActive = item.id === activeClass;
          return (
            <li key={item.id} role="button" tabIndex={-1} onClick={() => handleSelect(item.id)}>
              <Item variant={isActive ? 'muted' : 'outline'} className="hover:bg-muted cursor-pointer">
                <ItemHeader>
                  <ItemTitle>{t(item.labelKey)}</ItemTitle>
                </ItemHeader>
              </Item>
            </li>
          );
        })}
      </ul>
    </ScrollArea>
  );
};
